/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_Rev_Per_VisitorInputs */

const en_admin_funnel_col_rev_per_visitor = /** @type {(inputs: Admin_Funnel_Col_Rev_Per_VisitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue / visitor`)
};

/**
* | output |
* | --- |
* | "Revenue / visitor" |
*
* @param {Admin_Funnel_Col_Rev_Per_VisitorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_rev_per_visitor = /** @type {((inputs?: Admin_Funnel_Col_Rev_Per_VisitorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_Rev_Per_VisitorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_rev_per_visitor(inputs)
});
export { admin_funnel_col_rev_per_visitor as "admin.funnel.col.rev_per_visitor" }